import script from "./PasswordForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordForm.vue?vue&type=script&setup=true&lang=js"

import "./PasswordForm.vue?vue&type=style&index=0&id=791fa460&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791fa460"]])

export default __exports__